<template>
  <div :class="{ 'container-facial-result': !lightMode, 'container-facial-result-light': lightMode }">
    <div :class="{ 'container-spacing': !lightMode, 'container-spacing-light': lightMode }">
      <div :class="['container-head', { 'container-head-mobile': isMobile }]">
        <div class="pds-typography-body-22 result-title" v-if="isBrowserError || !isMobile">
          {{ resultTitle }}
        </div>
        <div v-if="isSuccess && isMobile" class="stepper">
          <Stepper :totalSteps="5" :activeStep="4" />
        </div>
      </div>
      <div
        v-if="!isBrowserError"
        :class="{ container: !lightMode, 'container-light': lightMode, 'container-mobile': isMobile }"
      >
        <div v-if="!isCameraBlocked" :class="{ 'container-message': !lightMode, 'container-message-light': lightMode }">
          <div class="img-error">
            <vue-feather
              v-if="!isSuccess && retryButtonActived"
              type="alert-triangle"
              size="32"
              stroke-width="3"
              stroke="#C00000"
            ></vue-feather>
            <img v-else :src="urlResultImage" :alt="imageAlt" />
          </div>
          <div>
            <div class="pds-typography-body-22 first-text">
              {{ descriptionText }}
            </div>
            <div class="pds-typography-body-16 text-info">
              <a v-if="!isSuccess"> {{ textError }} </a>
              <a v-else-if="isMobile && isFromDesktop">Hemos validado con éxito tu identidad. <strong>Ahora debes regresar a tu computador</strong> para continuar con el proceso.</a>
              <a v-else-if="isMobile && !isFromDesktop">Hemos validado con éxito tu identidad <span class='pds-typography-bold'>con reconocimiento facial,</span> ahora puedes continuar con el proceso.</a>
              <a v-else>Hemos validado con éxito tu identidad con reconocimiento facial.</a>
            </div>
            <PdsButton
              v-if="!this.isFromDesktop && isSuccess && isMobile"
              class="button"
              id="continuar"
              label="Continuar"
              :block="true"
              @click="closeWindow"
            />
          </div>
          <div class="container-button" v-if="retryButtonActived && !isSuccess">
            <PdsButton class="button" id="reintentar" label="Reintentar" :block="true" @click="retry()" />
          </div>
          <div v-if="isAutoClosing" class="pds-typography-body-16  message-success">
            <span class="message-front">Esta pestaña se cerrará en {{ autoCloseCountDown }} segundos.</span>
          </div>
          <div v-if="!isAutoClosing && closeMessage" class="pds-typography-body-16 message-success">
            <div class="first-info">
              Por favor cerrar la pestaña para terminar el flujo de autenticación.
            </div>
          </div>
        </div>
        <div v-else :class="{ 'container-message': !lightMode, 'container-message-light': lightMode }">
          <div class="img-error">
            <img :src="urlResultImage" :alt="imageAlt" />
          </div>
          <div>
            <div class="pds-typography-body-22 first-text">
              <span v-if="isMobile">Tu cámara está bloqueada</span>
              <span v-else>La cámara de tu celular está bloqueada</span>
            </div>
            <div class="pds-typography-body-16 text-info">
              <span v-if="isMobile">
                Para poder acceder al reconocimiento facial
                <strong>debes activar los permisos de tu cámara en el navegador de tu dispositivo.</strong>
              </span>
              <span v-else>
                Para poder completar el reconocimiento facial
                <strong>debes activar los permisos de tu cámara en el navegador de tu dispositivo móvil.</strong>
              </span>
            </div>
          </div>
          <div class="container-button" v-if="retryButtonActived && !isSuccess">
            <PdsButton class="button" id="reintentar" label="Reintentar" :block="true" @click="retry()" />
          </div>
          <div v-if="isAutoClosing" class="message-success">
            <span class="message-front">
              Esta pestaña se cerrará automaticamente en {{ autoCloseCountDown }} segundos.
            </span>
          </div>
          <div v-if="!isAutoClosing && closeMessage" class="message-success">
            <div class="pds-typography-body-16 first-info">
              Por favor cerrar la pestaña para terminar el flujo de autenticación.
            </div>
          </div>
        </div>
      </div>
      <div v-else class="tip-container">
        <div class="tip-card">
          <div class="hint-icon">
            <vue-feather type="check-circle" size="22" stroke="#0061A0"></vue-feather>
          </div>

          <div class="hint-text">
            <span>
              Intenta usar
              <strong>otro dispositivo</strong>
              para leer el QR
            </span>
          </div>
        </div>
        <div class="tip-card">
          <div class="hint-icon">
            <vue-feather type="check-circle" size="22" stroke="#0061A0"></vue-feather>
          </div>

          <div class="hint-text">
            <span>
              Intenta
              <strong>
                actualizar tu navegador
              </strong>
            </span>
          </div>
        </div>
      </div>
      <div v-if="isAutoClosing && isBrowserError" class="message-success">
        <span class="message-front">Esta pestaña se cerrará en {{ autoCloseCountDown }} segundos.</span>
      </div>
    </div>
  </div>
</template>
<script>
import VueFeather from "vue-feather";
import Stepper from "@vue-pds/stepper";
import PdsButton from "@vue-pds/button";

const BROWSER_ERROR_COUNT_DOWN = 8;
import Config from "@/utils/config";
export default {
  name: "FacialResult",
  components: {
    VueFeather,
    Stepper,
    PdsButton
  },
  props: {
    isSuccess: { type: Boolean },
    textError: { type: String },
    retryButtonActived: { type: Boolean, default: false },
    company: { type: String, default: "principal" },
    autoClose: { type: Boolean, default: false },
    tabTimer: { type: Number, default: 6 },
    lightMode: { type: Boolean, default: false },
    isBrowserError: { type: Boolean, default: false },
    isMobile: { type: Boolean, default: false },
    isCameraBlocked: { type: Boolean, default: false },
    environment: { type: String, default: "development" }
  },
  data() {
    return {
      urlResultImage: "",
      imageAlt: "",
      descriptionText: "",
      detailText: "",
      isAutoClosing: false,
      autoCloseDelay: 3000,
      autoCloseCountDown: 6,
      closeMessage: false,
      config: undefined,
      isFromDesktop: this.$route?.query?.isFromDesktop ? true : false
    };
  },
  created() {
    this.config = new Config(this.environment);
  },
  computed: {
    resultTitle() {
      if (this.isBrowserError) {
        return "Reconocimiento Facial no compatible con tu navegador";
      }
      return "Reconocimiento Facial";
    }
  },
  methods: {
    retry() {
      this.$emit("retry");
    },
    countDown() {
      if (this.autoCloseCountDown > 0) {
        setTimeout(() => {
          this.autoCloseCountDown -= 1;
          this.countDown();
        }, 1000);
      } else {
        this.closeWindow();
        this.isAutoClosing = false;
        this.closeMessage = true;
      }
    },
    closeWindow() {
      window.open("", "_self").close();
    }
  },
  mounted() {
    if (this.autoClose && (this.isFromDesktop || !this.isSuccess)) {
      if (this.isBrowserError) this.autoCloseCountDown = BROWSER_ERROR_COUNT_DOWN;
      else this.autoCloseCountDown = this.tabTimer;
      setTimeout(() => {
        this.isAutoClosing = true;
        this.countDown();
      }, this.autoCloseDelay);
    }
    if (this.isSuccess) {
      this.urlResultImage = this.config.successImage();
      this.imageAlt = "Success Image";
      this.descriptionText = "¡Muy bien!";
    } else {
      this.urlResultImage = this.config.errorImage();
      this.imageAlt = "Error Image";
      this.descriptionText = "Algo salió mal";
      this.detailText = this.textError;
    }
  }
};
</script>
<style scoped src="@pds/typography/typography.min.css"></style>
<style scoped>
.first-text {
  text-align: center;
  margin-top: 15px;
}
.container-facial-result {
  background-color: #fafafa;
  height: calc(100% - 40px);
  min-width: 340px;
}

.container-facial-result-light {
  height: inherit;
  background-color: #fafafa;
  min-width: 340px;
}
.container-spacing {
  padding: 2.5em 1em;
}

.container-spacing-light {
  height: inherit;
}

.container {
  margin: auto;
  border: 1px solid rgba(161, 161, 161, 0.603);
  border-radius: 6px;
  min-width: 320px;
  background-color: white;
  text-align: center;
  display: flex;
  flex-direction: column;
  width: 325px;
  padding-top: 30px;
}
.container-mobile {
  min-height: 400px;
}

.container-head {
  display: flex;
  flex-direction: row;
  width: 320px;
  padding-bottom: 30px;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
}

.container-head-mobile {
  padding-bottom: 19px;
}

.stepper {
  width: 100%;
}

.container-light {
  margin: auto;
  min-width: 320px;
  background-color: white;
  text-align: center;
  height: inherit;
  display: flex;
  flex-direction: column;
}

@media screen and (min-width: 600px) {
  .container {
    width: 555px;
    height: 555px;
    padding-top: 0;
  }

  .container-head {
    width: 620px;
  }
}

.container-message {
  margin: auto;
  width: 300px;
}

.container-message-light {
  margin: auto;
}

.img-error {
  padding: 0 0 16px;
}

.error-title {
  font-size: 22px;
  line-height: 26px;
  color: #464646;
}

.text-info {
  color: #464646;
  padding: 30px 0;
}

.container-button {
  padding-bottom: 4em;
}

.button {
  height: 50px;
  width: 300px;
  background-color: #0061a0;
  margin-bottom: 84px;
}

.message-front {
  height: 38px;
  width: 100%;
  font-size: 17px;
  letter-spacing: 0;
  line-height: 18.62px;
  text-align: center;
  color: #464646;
}

.message-success {
  display: flex;
  align-items: center;
  border-radius: 6px;
  height: 71px;
  margin-top: 30px;
  margin-bottom: 18px;
}

.result-title {
  line-height: 26px;
  width: 60%;
  text-align: center;
  margin: auto;
}

.tip-container {
  padding: 24px;
  margin: auto;
  border: 1px solid rgba(161, 161, 161, 0.603);
  border-radius: 6px;
  min-width: 320px;
  background-color: white;
  text-align: center;
  display: flex;
  flex-direction: column;
  width: 325px;
}

.tip-card {
  margin-top: 24px;
  font-size: 16px;
  line-height: 21px;
  text-align: left;
  width: 100%;
  display: flex;
}

.hint-icon {
  width: 8%;
  display: inline-block;
  margin: auto;
}

.hint-text {
  width: 85%;
  display: inline-block;
}

.text-info-container {
  display: flex;
  flex-direction: column;
  height: auto;
  border-radius: 6px;
  background-color: #d8f2ff;
  text-align: center;
  color: #333333;
  align-items: center;
}

.text-info-2 {
  height: auto;
  width: 280px;
  color: #333333;
  letter-spacing: 0;
  line-height: 18px;
  text-align: center;
  padding: 5px 0 5px 0;
  font-size: 17px;
}
</style>
